import React, { useState } from "react";
import InputText from "../ReusableComponents/InputText";
import { mainTable } from "../css/Common";
import AddScreenTitle from "../components/AddScreenTitle";
import MainLayout from "../components/MainLayout";
import Buttons from "../components/Buttons";
import { SalaryMappingHeader } from "../components/HeaderAttribute";
import GridPage from "../components/GridPage";
import SalaryMappingPopup from "../popup-containers/SalaryMappingPopup";
import PopUpButtons from "../components/PopUpButtons";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
// import { IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import { useEffect } from "react";
// import { BindAPI } from "../services/APIConnection";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import Loader from "../ReusableComponents/Loader";

const SalaryMapping = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
      
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [rowIndex, setRowIndex] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [bindSalaryMappingData, setBindSalaryMappingData] = useState([]);
  const [staffNameDD, setStaffNameDD] = useState([]);
  const [salaryGradeDD, setSalaryGradeDD] = useState([]);
  const [popUpDataDD, setPopUpDataDD] = useState({});
  const [popUpData, setPopUpData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [formFields, setFormFields] = useState({
    mstSalaryMappingId: 0,
    date: new Date(),
    mstStaffNameId: "",
    mstSalaryGradeId: "",
  });

  const [formFieldsError, setFormFieldsError] = useState({
    dateError: "",
    staffNameError: "",
    salaryGradeError: "",
  });

  var mstClientId = sessionStorage.getItem("MstClientId");

  useEffect(() => {
    // bind gird datas
    BindSalaryMapping();
  }, []);

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prevData) => ({ ...prevData, [name]: value }));
    if (value.trim() !== "") {
      setFormFieldsError((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };
  const handleBlur = () => {
    const updatedErrors = {
      ...formFieldsError,
      staffNameError: formFields.mstStaffNameId ? "" : "Select Staff Name",
      salaryGradeError: formFields.mstSalaryGradeId
        ? ""
        : "Select Salary Grade",
    };

    const isFormValid = Object.values(updatedErrors).every(
      (error) => error === ""
    );

    // Check for duplicates only if form is valid
    if (isFormValid) {
      const mstStaffNameId = parseInt(formFields.mstStaffNameId, 10);
      const mstSalaryGradeId = parseInt(formFields.mstSalaryGradeId, 10);

      const isDuplicate = bindSalaryMappingData.some(
        (data) =>
          data.MstStaffNameId === mstStaffNameId &&
          data.MstSalaryGradeId === mstSalaryGradeId &&
          data.MstSalaryMappingId !== formFields.mstSalaryMappingId
      );

      if (isDuplicate) {
        updatedErrors.salaryGradeError =
          "This Staff Name is already mapped to this Grade.";
      }
    }

    setFormFieldsError(updatedErrors);
    return Object.values(updatedErrors).every((error) => error === "");
  };

  const BindSalaryMapping = async () => {
    const data = {
      mstClientId: mstClientId,
    };
setIsLoading(true); 
    const response = await BindPostAPI(
      data,
      "SalaryMappingAPI/BindSalaryMapping"
    );

    if (response && response.data) {
      setBindSalaryMappingData(response.data.Table);

      const salary = response?.data?.Table1.map((item) => ({
        value: item?.MstGradeId,
        label: item?.Grade,
      }));

      setSalaryGradeDD(salary);

      const staff = response?.data?.Table2.map((item) => ({
        value: item?.MstStaffId,
        label: item?.StaffName,
      }));

      setStaffNameDD(staff);
      setIsLoading(false); 
    } else {
      setBindSalaryMappingData([]);
    }
  };

  const handleEdit = (rowIndex) => {
    setRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setFormFields({
      ...formFields,
      date: bindSalaryMappingData[rowIndex].Date.split("T")[0],
      mstSalaryMappingId: bindSalaryMappingData[rowIndex].MstSalaryMappingId,
      mstStaffNameId: bindSalaryMappingData[rowIndex].MstStaffNameId, // ✅ Fix applied here
      mstSalaryGradeId: bindSalaryMappingData[rowIndex].MstSalaryGradeId,
    });
  };

  const handlesalary = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);
    handleOpen(true);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    const staffOption = staffNameDD.find(
      (item) => item.value === bindSalaryMappingData[rowIndex].MstStaffNameId
    );
    const gradeOption = salaryGradeDD.find(
      (item) => item.value === bindSalaryMappingData[rowIndex].MstSalaryGradeId
    );

    setPopUpDataDD([staffOption, gradeOption]);

    setFormFields({
      ...formFields,
      mstSalaryMappingId: bindSalaryMappingData[rowIndex].MstSalaryMappingId,
    });
    setPopUpDataDD([staffNameDD, salaryGradeDD]);
    setPopUpData(bindSalaryMappingData[rowIndex]);
  };

  const cancel = () => {
    BindSalaryMapping();
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setFormFields({
      date: new Date(),
      mstStaffNameId: "",
      mstSalaryGradeId: "",
    });
    setFormFieldsError({});
    setpopUpOpen(false);
    setIsLoading(false);
    setSubmitBtnDisabled(false);
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setFormFields({
      ...formFields,
      date: formattedDate,
    });
  };

  const handleFieldsChange = (value, name) => {
    setFormFields((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormFieldsError((prevErrors) => ({
      ...prevErrors,
      [`${name === "mstStaffNameId" ? "staffNameError" : "salaryGradeError"}`]:
        "",
    }));
  };

  const createdBy = sessionStorage.getItem("createdBy");
  const handleSubmit = async (items, flag) => {
    const isValid = handleBlur();
    const updatedErrors = {
      ...formFieldsError,
      staffNameError: formFields.mstStaffNameId ? "" : "Select Staff Name",
      salaryGradeError: formFields.mstSalaryGradeId
        ? ""
        : "Select Salary Grade",
    };

    const isFormValid = Object.values(updatedErrors).every(
      (error) => error === ""
    );

    if (isFormValid) {
      const mstStaffNameId = parseInt(formFields.mstStaffNameId);
      const mstSalaryGradeId = parseInt(formFields.mstSalaryGradeId);

      const isDuplicate = bindSalaryMappingData.some(
        (data) =>
          data.MstStaffNameId === mstStaffNameId &&
          data.MstSalaryGradeId === mstSalaryGradeId &&
          data.MstSalaryMappingId !== formFields.mstSalaryMappingId
      );

      if (isDuplicate) {
        updatedErrors.salaryGradeError =
          "This Staff Name is already mapped to this Grade.";
      } else {
        updatedErrors.salaryGradeError = "";
      }
    }

    setFormFieldsError(updatedErrors);
    const isFormValidCheck = Object.values(updatedErrors).every(
      (error) => error === ""
    );

    if (flag == 1 || flag == 2) {
      // if (staffNameError1 == "")
      if (isValid) {
        setIsLoading(true);
        setSubmitBtnDisabled(true);
        const payload = {
          mstSalaryMappingId: formFields.mstSalaryMappingId
            ? formFields.mstSalaryMappingId
            : 0,
          mstClientId: mstClientId,
          date: formFields.date,
          mstStaffNameId: parseInt(formFields.mstStaffNameId, 10),
          mstSalaryGradeId: parseInt(formFields.mstSalaryGradeId, 10),
          createdby: parseInt(createdBy, 10),
          flag: flag,
        };

        const response = await IUDAPI(
          payload,
          "SalaryMappingAPI/IUDSalaryMapping"
        );

        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Map Staff and Grade Added Successfully 👍", {
              duration: 1000,
              position: "top-center",
            });

            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Map Staff and Grade data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }

          // Handle Update
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Map Staff and Grade  updated successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to update Map Staff and Grade data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        setIsOpen(true);
      }
    } else {
      setSubmitBtnDisabled(true);   
      setIsLoading(true); 
      const data = {
        mstSalaryMappingId: bindSalaryMappingData[items].MstSalaryMappingId,
        createdby: parseInt(createdBy, 10),
        flag: flag,
      };
      const response = await IUDAPI(data, "SalaryMappingAPI/IUDSalaryMapping");

      // Handle Delete
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Map Staff and Grade data deleted successfully 🗑️", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error("Failed to delete Map Staff and Grade data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
        // Handle In Active
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            "Map Staff and Grade Data In Activated successfully 🚫",
            {
              duration: 2000,
              position: "top-center",
            }
          );
          setTimeout(cancel, 2000);
        } else {
          toast.error("Failed to In Active Map Staff and Grade data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }

        // Handle Active
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Map Staff and Grade Data Activated successfully ✅", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error("Failed to  Active Map Staff and Grade data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
          setSubmitBtnDisabled(false);  
          setIsLoading(false);
        }
    
      }
   
    }
    
  };

  return (
    <>
      <MainLayout pageName={"2"}>
        <Loader
          isVisible={isLoading}
          size="h-20 w-20"
          color="border-t-black"
          blur={true}
        />
        {visibleTable && (
          <GridPage
            header={SalaryMappingHeader}
            title={"Map Staff and Grade"}
            records={bindSalaryMappingData}
            handleEdit={handleEdit}
            handleAction={handlesalary}
            showAdd={showAdd}
            blockview={true}
          />
        )}

        {visibleAdd && (
          <div className="w-full">
            <div className="flex flex-col w-full">
              <div className={mainTable.clientMasterMainAdd}>
                <AddScreenTitle
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  title="Map Staff and Grade"
                />
              </div>
            </div>
            <div className="mx-auto mt-16 md:w-[500px] w-full flex items-center justify-center">
              <div className="relative w-full h-full max-w-xl md:h-auto">
                <div className="relative bg-white rounded-lg shadow">
                  <div className="px-6 py-6 lg:px-8">
                    <div className="flex gap-2 flex-col">
                      <InputText
                        inputType="date"
                        title="Date"
                        classStar="text-red-500"
                        name="date"
                        disabled={false}
                        content={formFields.date}
                        controlFunc={(e) =>
                          setFormFields({ ...formFields, date: e.target.value })
                        }
                        controlFuncBlur={() => {}}
                        errorMessage={formFieldsError.dateError}
                        inputClassName="w-1/4"
                      />

                      <AutoDropDown
                        selectedOption={staffNameDD.find(
                          (x) => x.value == formFields.mstStaffNameId
                        )}
                        title="Staff Name"
                        classStar={"text-red-500"}
                        inputType="dropdown"
                        options={staffNameDD}
                        name="mstStaffNameId"
                        controlFunc={(value, e) => {
                          handleFieldsChange(value.value, e.name);
                        }}
                        controlFuncBlur={() => {}}
                        errorMessage={formFieldsError.staffNameError}
                        placeholder="Select Staff Name"
                        Class="custom-class"
                        // tabIndex="1"
                      />

                      <AutoDropDown
                        selectedOption={salaryGradeDD.find(
                          (x) => x.value == formFields.mstSalaryGradeId
                        )}
                        title="Salary Grade"
                        classStar={"text-red-500"}
                        inputType="dropdown"
                        options={salaryGradeDD}
                        name="mstSalaryGradeId"
                        controlFunc={(value, e) => {
                          handleFieldsChange(value.value, e.name);
                        }}
                        controlFuncBlur={() => {
                          handleBlur();
                        }}
                        errorMessage={formFieldsError.salaryGradeError}
                        placeholder="Select Salary Grade"
                        Class="custom-class"
                        // tabIndex="1"
                      />
                    </div>
                    <Buttons
                      addScreenTitle={addScreenTitle}
                      updateScreenTitle={updateScreenTitle}
                      disabledBtn={false}
                      viewSaveButton={false}
                      handleSubmit={handleSubmit}
                      cancel={cancel}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
   {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
        <MainPopup
          popUpOpen={popUpOpen}
          setpopUpOpen={setpopUpOpen}
          Open={handlesalary}
        >
          <div>
            <PopUpScreenTitle
              title="Map Staff and Grade"
              setpopUpOpen={setpopUpOpen}
              viewDetails={viewDetails}
              deleteDetails={deleteDetails}
              
              blockDetails={blockDetails}
              unBlockDetails={unBlockDetails}
            />
            <SalaryMappingPopup data={popUpData} data1={popUpDataDD} />
          </div>
          <PopUpButtons
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
            rowIndex={rowIndex}
            handleSubmit={handleSubmit}
            cancel={cancel}
            disabledBtn={submitBtnDisabled}
          />
        </MainPopup>
      </MainLayout>
    </>
  );
};
export default SalaryMapping;
